const commentsData = [
  {
    name: '追剧小达人',
    time: '3天前',
    rating: 5,
    content: '8090影院真的太好用了！画质清晰不卡顿，更新速度超级快，狂飙2026刚播完第二天就能看了。已经推荐给身边所有追剧的朋友，大家都说好用！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20clean%20studio%20lighting%20on%20neutral%20background%2C%20friendly%20and%20approachable%20expression%2C%20simple%20elegant%20style%2C%20soft%20natural%20makeup%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '电影迷阿杰',
    time: '5天前',
    rating: 5,
    content: '作为一个重度追剧用户，用过很多平台，8090影院的体验是最好的。4K画质真的很震撼，关键是免费！暗夜追光每一集我都追，画质和音效不输视频会员。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20confident%20smile%2C%20clean%20studio%20lighting%20on%20neutral%20background%2C%20friendly%20and%20relaxed%20expression%2C%20modern%20casual%20style%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '长安旧梦',
    time: '1周前',
    rating: 4,
    content: '古装剧资源很全，长安十二时辰全集的画质特别好，服化道的细节都能看清楚。希望能增加更多经典老剧的高清资源，很多小时候看的剧想重温。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20gentle%20smile%2C%20clean%20studio%20lighting%20on%20neutral%20background%2C%20warm%20and%20genuine%20expression%2C%20simple%20minimalist%20style%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-user-03&orientation=squarish',
  },
  {
    name: '剧荒拯救者',
    time: '2周前',
    rating: 5,
    content: '之前一直为追剧找资源发愁，自从发现了8090影院，再也不用到处找了。更新及时、分类清晰、推荐精准，编辑推荐的每一部都很好看，剧荒患者的福音！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20bright%20smile%2C%20clean%20studio%20lighting%20on%20neutral%20background%2C%20energetic%20and%20friendly%20expression%2C%20modern%20casual%20style%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-user-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-chat-heart-line"></i>
            真实反馈
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">用户好评</h2>
          <p className="mt-2 text-foreground-500 text-sm">来自真实追剧用户的评价与反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const el = e.currentTarget;
                      el.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}